<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery">
          <gj-warehouse-select
              v-model="filter.warehouseIds"
              placeholder="仓库"
              :self="false"
              width="180px"
              multiple
          ></gj-warehouse-select>
          <gj-select-input
              v-model="filter.keyword0"
              :options="[
                {id: 'sku', text: 'SKU'},
                {id: 'skuName', text: '产品名称'},
              ]"
              :width="['100px', '100px']"
          ></gj-select-input>
          <gj-select-input
              v-model="filter.keyword1"
              :options="[
                {id: 'msku', text: 'MSKU'},
                {id: 'fnsku', text: 'FNSKU'},
                {id: 'asin', text: 'ASIN'},
              ]"
              :width="['100px', '100px']"
          ></gj-select-input>
          <gj-select
              v-model="filter.state"
              :options="option.stateOption"
              placeholder="同步状态"
          ></gj-select>
          <gj-select
              v-model="filter.currency"
              :options="[
                {id: 'CNY', text: 'CNY'},
                {id: 'USD', text: 'USD'},
              ]"
              width="80px"
              :clearable="false"
              placeholder="币种"
          ></gj-select>
          <gj-date-picker
              v-if="false"
              v-model="filter.date"
              type="daterange"
              tooltip="更新时间"
          ></gj-date-picker>
          <template #advancedFilter>
            <gj-category-select
                v-model="filter.categoryIds"
                multiple
            ></gj-category-select>
            <gj-operation-state-select
                v-if="false"
                v-model="filter.operationStates"
                width="120px"
                placeholder="商品运营状态"
            ></gj-operation-state-select>
            <gj-select
                v-model="filter.afn"
                width="120px"
                :options="option.afnOption"
                placeholder="配送渠道"
            ></gj-select>
            <gj-select
                v-model="filter.productType"
                width="120px"
                :options="option.productTypeOption"
                placeholder="产品类型"
            ></gj-select>
          </template>
          <template #right>
            <gj-tool-group
                :download="$permission('fbaInventory:export')" download-url="/supply/storage/exportFbaInventory" :download-params="globalParams"
                setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
                help
            ></gj-tool-group>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"

            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            :loading="loading"
            :size="'has-picture'"
            show-summary
            :summary-object="summaryObject"
            :default-sort = "{prop: 'fulfillableQuantity', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
          <template v-slot:warehouseName="{ row }">
            <gj-tooltip :content="row.warehouseName" :text-line="2">
              {{row.warehouseName | defaultShow}}
            </gj-tooltip>
          </template>
          <template v-slot:sku="{ row }">
            <el-row>
              <el-col :span="21"><gj-tooltip :text-line="1" :content="row.sku">{{row.sku}}</gj-tooltip></el-col>
              <el-col :span="3">
                <span v-copy="row.sku"
                      class="copy-icon gj-cell-display-switch">
                  <gj-icon class="el-icon-copy-document"></gj-icon>
                </span>
              </el-col>
            </el-row>
            <div>
              <gj-tooltip :text-line="1" :content="row.skuName">{{row.skuName}}</gj-tooltip>
            </div>
          </template>
          <template v-slot:sevenDaysPses="{ row }">
            <template v-if="isMeaningful(row.sevenDaysSalesDetailsList)">
              <gj-popover-panel
                  :title="'7天销量'"
                  :width="'180px'"
                  :data="buildSevenDaysSales(row.sevenDaysSalesDetailsList)">
                {{row.sevenDaysPses | defaultShow}}
              </gj-popover-panel>
            </template>
            <template v-else>{{row.sevenDaysPses | defaultShow}}</template>
          </template>
          <template v-slot:totalAmount="{ row }">
            <gj-popover-panel
                :title="'总货值 = 可售货值 + 不可售货值'"
                :width="'200px'"
                :data="[
                  {label: '可售货值', value: row.fulfillableAmount},
                  {label: '不可售货值', value: row.unsellableAmount},
                ]">
              {{row.totalAmount | defaultShow}}
            </gj-popover-panel>
          </template>
          <template v-slot:unsellableAmount="{ row }">
            <gj-popover-panel
                :title="'不可售货值 = 不可售 * (采购成本 + 到库成本)'"
                :width="'300px'"
                :data="[
                  {label: '不可售', value: row.unsellableQuantity},
                  {label: '采购成本', value: row.purchaseCost},
                  {label: '到库成本', value: row.arriveCost},
                ]">
              {{row.unsellableAmount | defaultShow}}
            </gj-popover-panel>
          </template>
          <template v-slot:fulfillableAmount="{ row }">
            <gj-popover-panel
                :title="'可售货值 = 可售 * (采购成本 + 到库成本)'"
                :width="'250px'"
                :data="[
                  {label: '可售', value: row.fulfillableQuantity},
                  {label: '采购成本', value: row.purchaseCost},
                  {label: '到库成本', value: row.arriveCost},
                ]">
              {{row.fulfillableAmount | defaultShow}}
            </gj-popover-panel>
          </template>
          <template v-slot:saleableTurnover="{ row }">
            <gj-popover-panel
                :title="'可售周转 = 可售 / 7天日均'"
                :width="'200px'"
                :data="[
                  {label: '可售', value: row.fulfillableQuantity},
                  {label: '7天日均', value: row.computePs},
                ]">
              {{row.saleableTurnover | defaultShow}}
            </gj-popover-panel>
          </template>
          <template v-slot:unsalableQuantity="{ row }">
            <template v-if="row.unsalableQuantity !== 0">
              <gj-popover-panel
                  :title="'滞销详情'"
                  :width="'180px'"
                  :data="buildUnsalable(row.unsalableDetailsList)">
                {{row.unsalableQuantity | defaultShow}}
              </gj-popover-panel>
            </template>
            <template v-else>{{row.unsalableQuantity | defaultShow}}</template>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin} from "../../../../minxins";
  import {exportFbaInventory, getFbaInventory} from "../../../../api/warehouse";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import model from './viewConfig'

  export default {
    name: "app-fba-inventory",
    mixins: [queryMixin, isMeaningfulMixin],
    created() {
      this.sort.prop = 'fulfillableQuantity';
    },
    data() {
      return {
        tableName: 'fbaInventory',
        tableData: [],
        columns: [
          {id: 'warehouseName', header: '仓库名称', field: 'slot:warehouseName', minWidth: '130px', fixed: "left", sortable: true, default: true},
          {id: 'smallImageUrl', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px', fixed: "left", default: true},
          {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '140px', fixed: "left", sortable: true, default: true, copyable: true, overflowLine: 1},
          {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '140px', sortable: true, default: true, copyable: true},
          {id: 'SKU', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '220px', sortable: true, default: true},
          {id: 'asin', header: 'ASIN', field: 'asin', minWidth: '140px', sortable: true, default: true,copyable: true},
          {id: 'state', header: '同步状态', help: '异常：表示本次同步较上一次同步该数据已被亚马逊报表删除', field: 'option:state', minWidth: '85px', default: true, options: [{id: 'Normal', text: '正常'}, {id: 'Abnormal', text: '异常'},]},
          {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '120px', overflowLine: 2, sortable: true, default: true},
          {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '120px', overflowLine: 2, sortable: true},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '90px', default: true, options: [{id: 'Product', text: '普通产品'}, {id: 'Assembly', text: '组合产品'},]},
          {id: 'afn', header: '配送渠道', field: 'option:afn', minWidth: '80px', default: true, options: [{id: true, text: '亚马逊配送'}, {id: false, text: '卖家自配送'},]},
          {id: 'expectDeliveryDays', header: '预计交期', field: 'expectDeliveryDays', minWidth: '90px', align: 'right', sortable: true},
          // {id: '1', header: '商品运营状态', field: 'country', minWidth: '100px'},
          // {id: '1', header: '商品运营级别', field: 'country', minWidth: '100px'},
          {id: 'workingQuantity', header: '计划入库', summary: true, help: 'afn-inbound-working-quantity', field: 'workingQuantity', minWidth: '105px', sortable: true, align: 'right'},
          {id: 'shippedQuantity', header: '已发货', summary: true, help: 'afn-inbound-shipped-quantity', field: 'shippedQuantity', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'receivingQuantity', header: '入库中', summary: true, help: 'afn-inbound-receiving-quantity', field: 'receivingQuantity', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'fbmFulfillableQuantity', header: 'FBM可售', summary: true, help: 'mfn-fulfillable-quantity', field: 'fbmFulfillableQuantity', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'fulfillableQuantity', header: 'FBA可售', summary: true, help: 'afn-fulfillable-quantity', field: 'fulfillableQuantity', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'reservedQuantity', header: '预留', summary: true, help: 'afn-reserved-quantity', field: 'reservedQuantity', minWidth: '80px', sortable: true, align: 'right', default: true},
          {id: 'reservedCustomerorders', header: '买家订单', summary: true, help: 'Reserved Customer orders', field: 'reservedCustomerorders', minWidth: '105px', sortable: true, align: 'right'},
          {id: 'reservedTransfers', header: '转运中',  summary: true,help: 'Reserved FC transfer', field: 'reservedTransfers', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'reservedProcessing', header: '处理中', summary: true, help: 'Reserved FC processing', field: 'reservedProcessing', minWidth: '95px', sortable: true, align: 'right'},
          {id: 'unsellableQuantity', header: '不可售', summary: true, help: 'afn-unsellable-quantity', field: 'unsellableQuantity', minWidth: '95px', sortable: true, align: 'right', default: true},
          {id: 'researchingQuantity', header: '正在调查', summary: true, help: 'afn-researching-quantity', field: 'researchingQuantity', minWidth: '110px', sortable: true, align: 'right'},
          {id: 'reservedFutureSupply', header: '预留未来供货', summary: true, help: 'afn-reserved-future-supply', field: 'reservedFutureSupply', minWidth: '135px', sortable: true, align: 'right'},
          {id: 'futureSupplyBuyable', header: '可购未来供货', summary: true, help: 'afn-future-supply-buyable', field: 'futureSupplyBuyable', minWidth: '135px', sortable: true, align: 'right'},
          {id: 'computePs', header: '7天日均', summary: true, help: '前天至-8天的日均销量（销售订单里除了“canceled、NoStatus”状态）', field: 'computePs', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'sevenDaysPses', header: '7天销量', summary: true, help: '前天至-8天的销量（销售订单里除了“canceled、NoStatus”状态）', field: 'slot:sevenDaysPses', minWidth: '190px', align: 'right', default: true},
          {id: 'saleableTurnover', header: '可售周转', summary: true, help: '可售 / 7天日均', field: 'slot:saleableTurnover', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'purchaseCost', header: '采购成本', permission: 'cost:view', help: '来源-成本中心结转的固定成本', field: 'purchaseCost', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'arriveCost', header: '到库成本', permission: 'cost:view', help: '来源-成本中心结转的固定成本', field: 'arriveCost', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'fulfillableAmount', header: 'FBA可售货值', summary: true, permission: 'cost:view', help: 'FBA可售 * （采购成本+到库成本）', field: 'slot:fulfillableAmount', minWidth: '140px', sortable: true, align: 'right', default: true},
          {id: 'unsellableAmount', header: '不可售货值', summary: true, permission: 'cost:view', help: '不可售 * (采购成本 + 到库成本)', field: 'slot:unsellableAmount', minWidth: '120px', sortable: true, align: 'right', default: true},
          {id: 'totalAmount', header: '总货值', summary: true, permission: 'cost:view', help: 'FBA可售货值+不可售货值', field: 'slot:totalAmount', minWidth: '110px', sortable: true, align: 'right', default: true},
          {id: 'invAge0To30Days', header: '0-30天库龄', summary: true, field: 'invAge0To30Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge31To60Days', header: '31-60天库龄', summary: true, field: 'invAge31To60Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          {id: 'invAge61To90Days', header: '61-90天库龄', summary: true, field: 'invAge61To90Days', minWidth: '120px', align: 'right', default: true, sortable: true},
          // {id: 'invAge0To90Days', header: '0-90天库龄', summary: true, field: 'invAge0To90Days', minWidth: '110px', align: 'right', default: true, sortable: true},
          {id: 'invAge91To180Days', header: '91-180天库龄', summary: true, field: 'invAge91To180Days', minWidth: '125px', align: 'right', default: true, sortable: true},
          {id: 'invAge181To270Days', header: '181-270天库龄', summary: true, field: 'invAge181To270Days', minWidth: '135px', align: 'right', default: true, sortable: true},
          {id: 'invAge271To365Days', header: '271-365天库龄', summary: true, field: 'invAge271To365Days', minWidth: '135px', align: 'right', default: true, sortable: true},
          {id: 'invAge365PlusDays', header: '365天以上库龄', summary: true, field: 'invAge365PlusDays', minWidth: '125px', align: 'right', default: true, sortable: true},

          {id: 'unsalableQuantity', header: '滞销', summary: true, help: '根据用户设置滞销天数多少计算滞销', field: 'slot:unsalableQuantity', minWidth: '75px', align: 'right', default: true},
          {id: 'unsalableRate', header: '滞销率', summary: true, help: '( 滞销量 / (可售 + 预留) )*100%', field: 'unsalableRate', minWidth: '75px', align: 'right', suffix: '%'},
          {id: 'unsalableAmount', header: '滞销货值', summary: true, permission: 'cost:view', help: '滞销 * (采购成本 + 到库成本)', field: 'unsalableAmount', minWidth: '85px', align: 'right'},
          // {id: '16', header: '销售负责人', help: '滞销 * (采购成本 + 到库成本)', field: 'country', minWidth: '85px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '160px', default: true, sortable: true},
        ],
        filter: {
          warehouseIds: [],
          categoryIds: [],
          keyword0: {
            key: 'sku',
            value: ''
          },
          keyword1: {
            key: 'msku',
            value: ''
          },
          state: null,
          currency: 'CNY',
          date: null,
          operationStates: null,
          afn: null,
          productType: null,
        },
        option: {
          stateOption: [
            {id: 'Normal', text: '正常'},
            {id: 'Abnormal', text: '异常'},
          ],
          productTypeOption: [
            {id: 'Product', text: '普通产品'},
            {id: 'Assembly', text: '组合产品'},
          ],
          afnOption: [
            {id: true, text: '亚马逊配送'},
            {id: false, text: '卖家自配送'},
          ]
        },
        moduleName: 'FBA_INVENTORY',
        model,
        summaryObject: null,
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : [params.startDateTime, params.endDateTime]
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQuery() {
        const params = {
          model: {
            ...this.filter,
            productTypes: isMeaningful(this.filter.productType) ? [this.filter.productType] : null,
            afn: defaultVal(this.filter.afn, null),
            state: defaultVal(this.filter.state, null),
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        params.model[this.filter.keyword0.key] = this.filter.keyword0.value;
        params.model[this.filter.keyword1.key] = this.filter.keyword1.value;
        if (isMeaningful(this.filter.date)) {
          params.model.startUpdateTime = convertToDate(this.filter.date[0]);
          params.model.endUpdateTime = convertToDate(this.filter.date[1]);
        }
        if (isMeaningless(params.model.warehouseIds)) {
          params.model.warehouseIds = [];
        }
        this.globalParams = params;
        this.loading = true;
        getFbaInventory(params)
          .then((data) => {
            this.tableData = data.records;
            this.summaryObject = data.statisticRecord;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            categoryIds: [],
            keyword0: {
              key: 'sku',
              value: ''
            },
            keyword1: {
              key: 'msku',
              value: ''
            },
            state: null,
            currency: 'CNY',
            date: null,
            operationStates: null,
            afn: null,
            productType: null,
          }
        }
      },
      exportData() {
        exportFbaInventory(this.globalParams);
      },
      buildUnsalable(item) {
        return (item || []).map(v => {
          return {label: v.ageRange, value: v.quantity};
        })
      },
      buildSevenDaysSales(items) {
        return (items || []).map(e => ({
          label: e.date,
          value: e.quantity,
        }));
      }
    }
  }
</script>

<style scoped lang="scss">
.vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
  overflow-x: hidden;
}
// /deep/.fixed-left--wrapper.vxe-table--body-wrapper  {
//   overflow-x: hidden !important;
// }
</style>
